import { BaseModal } from "@/components/modal/BaseModal.tsx";
import CreateWorkspace from "@/components/pages/CreateWorkspace.tsx";
import { useSelector } from "react-redux";
import { RootState } from "@/store/modules";
import { FolderPlus } from "lucide-react";
// import WorkspaceIcon from "@/assets/icons/workspace-chooser-svgrepo-com.svg"

export default function CreateNewWorkSpaceModal() {
  const baseState = useSelector((state: RootState) => state.base);
  const workSpaceData = baseState.modalOptions.payload;
  return (
    <BaseModal
      title={workSpaceData ? "Edit Workspace" : "Create New Workspace"}
   
      size={"md"}
      icon={FolderPlus}
      showHeader={true}
    >
      <CreateWorkspace />
    </BaseModal>
  );
}
